import { NavTreeItem } from "../../../../components/common/navigation";
import { useTranslation } from "../../../../hooks/useTranslation";
import { UserRole } from "../../../../models/user.model";

const ALL_ROLES: UserRole[] = [UserRole.User, UserRole.Manager, UserRole.Admin];

// Static-content topic — no backend data, so this is a single leaf NavTreeItem
// with no children, same shape as the Profile Completion topic's final design.
export const useCertificatesFaqTree = (): NavTreeItem | null => {
    const { t } = useTranslation();

    return {
        id: "certificates",
        label: t("FAQ_TOPIC_CERTIFICATES", undefined, "Certificates"),
        path: "certificates",
        requiredRoles: ALL_ROLES,
    };
};
